import styles from './styles.module.scss'

import { Card, Switch, Button } from 'antd';

import { useContext, useState } from 'react';

import { UserContext } from '@/context/user';
import { setUserContextItem, removeUserContextItem } from '@/persistence/user_context';

import { sendEvent } from '@/utils/ga';

export const DebugModeAttribute = () => {
  const { debugMode, setDebugMode } = useContext(UserContext)

  const onDebugModeChange = (checked: boolean) => {
    setUserContextItem({ key: 'debug_mode', value: checked })
    setDebugMode(checked)

    window.location.reload()
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  const onTest = () => {
    sendEvent('test', {
      hello: 'world',
    })
  }

  return (
    <>
      <Card
        title="디버그 모드"
        bodyStyle={bodyMinHeightStyle}
        bordered={true}>
        {
          debugMode && (
            <p>현재 디버그 모드를 사용하고 있습니다.</p>
          )
        }
        {
          !debugMode && (
            <p>현재 디버그 모드를 사용하고 있지 않습니다.</p>
          )
        }
        <Switch
          checkedChildren="사용중"
          unCheckedChildren="미사용"
          defaultChecked={debugMode}
          checked={debugMode}
          onChange={(checked) => onDebugModeChange(checked)}
        />
        {
          debugMode && (
            <div className={styles.rowButton}>
              <Button type="primary" onClick={(e) => onTest() }>테스트</Button>
            </div>
          )
        }
      </Card>
    </>
  )
}
